import { render, staticRenderFns } from "./x-toggle.vue?vue&type=template&id=74c0768d&scoped=true&"
import script from "./x-toggle.vue?vue&type=script&lang=ts&"
export * from "./x-toggle.vue?vue&type=script&lang=ts&"
import style0 from "./x-toggle.vue?vue&type=style&index=0&id=74c0768d&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c0768d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
